module.exports = __webpack_public_path__ + "img/bh_19.9c2b9052.jpg";